var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReject(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 465.81 465.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #ff3e3e;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M457.39,210.49c-2.49-3.53-5.02-7.18-8.18-10.07-11.44-10.42-23-20.72-34.81-30.72-7.96-6.74-11.42-14.89-10.05-25.18,.77-5.78,1.73-11.55,2.18-17.36,1.06-13.64,1.73-27.3-1.62-40.78-3.42-13.75-11.91-22.45-25.79-25.58-4.21-.95-8.56-2.05-12.8-1.9-14.78,.54-29.58,1.22-44.31,2.58-10.72,.99-19.36-1.87-26.03-10.39-3.29-4.2-6.54-8.42-9.93-12.54-9.55-11.62-19.58-22.77-32.14-31.26-14.3-9.67-27.05-9.72-41.41-.15-4,2.67-8.12,5.46-11.35,8.96-10.49,11.37-20.83,22.91-30.77,34.76-7.08,8.44-15.55,11.97-26.45,10.53-10.56-1.39-21.18-2.34-31.77-3.48-.02,.13-.04,.25-.06,.38-4.99,.23-10.01,.24-14.98,.72-24.61,2.37-36.92,14.56-37.81,39.33-.51,14.24,.31,28.68,2.12,42.82,1.72,13.45-2.47,22.81-12.92,31.23-12.53,10.1-24.88,20.78-35.5,32.81-17.31,19.61-17.37,35.61-.07,55.15,10.96,12.38,23.84,23.21,36.63,33.79,9.58,7.93,13.73,16.89,11.91,29.23-2.42,16.34-3.66,32.8-1.42,49.32,2.77,20.46,12.84,30.51,33.21,33.19,16.02,2.1,32.01,1.2,47.81-1.36,13.82-2.24,23.35,2.62,31.95,13.41,10.02,12.58,21.68,23.87,32.72,35.62,1.57,1.68,3.63,2.93,5.56,4.24,15.52,10.55,28.57,10.55,43.92-.34,15.84-11.24,27.97-26.12,39.53-41.45,7.27-9.64,16.36-13.38,28.31-11.66,16.52,2.37,33.12,3.71,49.81,1.49,19.54-2.6,29.28-11.63,32.71-30.8,.79-4.41,1.48-8.96,1.29-13.41-.57-13.3-1.26-26.62-2.56-39.86-1.07-10.92,1.96-19.66,10.83-26.29,4.13-3.09,8.43-6.07,12.1-9.67,10.2-10.01,21.04-19.57,29.9-30.69,11.84-14.88,11.21-29.09,.26-44.63Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 135.49,
    y: 215.29,
    width: 194.83,
    height: 35.1,
    rx: 16.44,
    ry: 16.44,
    transform: "translate(232.86 -96.49) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 135.49,
    y: 215.29,
    width: 194.83,
    height: 35.1,
    rx: 16.44,
    ry: 16.44,
    transform: "translate(562.23 232.79) rotate(135)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReject);
export default __webpack_public_path__ + "static/media/reject.01f301a082e1eda0d3cdd6c978d834a7.svg";
export { ForwardRef as ReactComponent };